import caller from "../../helpers/caller";

export default async function putInsertDocumentSubType(api, params) {
  const response = await caller(api.put, "/document_sub_type/insert", null, {
    params,
  });
  return response;
}
